import {
  Box,
  Container,
  Link,
  Grid,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../Analysis/Assets/Logo/logo2.svg";
import OptionsGrid from "../components/OptionsGrid";
import { questions } from "../data/data";
import RadioOptions from "../components/RadioOptions";
import INIT_STATE from "../data/INIT_STATE";
import {
  useAnalysisGetMutation,
  useQuizSubmitMutation,
} from "../../app/services/quizCore";
import "../../Analysis/components/ToggleSidebar.css";
import { useCookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const Quiz = () => {
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(["o1JraEmail"]);

  const totalCnt = questions.length;
  const [loader, setLoader] = useState(false);
  const [quesCnt, setQuesCnt] = useState(0);
  const [currQuestion, setCurrQuestion] = useState(questions[quesCnt]);
  const [userEmail, setUserEmail] = useState(cookies.o1JraEmail);
  const [quizData, setQuizData] = useState(INIT_STATE);

  const [
    jraGetApiCall,
    {
      data: responseDataAnalysisGet,
      isLoading: isAnalysisGetLoading,
      isError: isAnalysisGetError,
      isSuccess: isAnalysisGetSuccess,
      error: errorAnalysisGet,
    },
  ] = useAnalysisGetMutation();

  useEffect(() => {
    if (userEmail) {
      setLoader(true);
      jraGetApiCall({
        email: userEmail,
      });
    }
  }, [userEmail]);

  useEffect(() => {
    if (isAnalysisGetSuccess) {
      toast.success("You have already attempted the test", {
        toastId: "analysisSuccess",
      });
      setTimeout(() => {
        navigate(`/analysis/${userEmail}`);
      }, 2000);
    } else {
      setLoader(false);
    }
  }, [isAnalysisGetSuccess, isAnalysisGetError]);

  useEffect(() => {
    setCurrQuestion(questions[quesCnt]);
  }, [quesCnt]);

  const handlePrevQuestion = () => {
    if (quesCnt == 0) {
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      setQuesCnt(quesCnt - 1);
    }, 500);
  };

  const [
    jraApiCall,
    { data: responseData, isLoading, isError, isSuccess, error },
  ] = useQuizSubmitMutation();

  const handleNextQuestion = () => {
    if (quesCnt == totalCnt - 1) {
      jraApiCall({
        email: userEmail,
        questions: quizData["questions"],
      });
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      setQuesCnt(quesCnt + 1);
    }, 500);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success(responseData.message, {
        toastId: "quizSuccess",
      });
      setTimeout(() => {
        navigate(`/analysis/${userEmail}`);
      }, 2000);
    } else if (isError) {
      toast.error(error.data.message, {
        toastId: "quizError",
      });
      setTimeout(() => {
        navigate("/");
      }, 2000);
    }
  }, [isSuccess, isError]);

  useEffect(() => {
    toast.info(
      "If you don't have any knowledge about the subject, directly click on Next",
      {
        autoClose: 5000,
        draggable: true,
        toastId: "initial",
      }
    );
  }, []);

  return (
    <div>
      <Container maxWidth="xl">
        <div className="container-fluid mt-3 mb-3">
          <nav className="navbar navbar-expand-lg shadow-md">
            <div className="container-fluid p-2">
              <Link className="navbar-brand text-primary mr-0" to="/" href="/">
                <img
                  className="brand-logo"
                  src={Logo}
                  alt="O(1) Coding Club"
                  srcSet=""
                />
              </Link>
              <h3
                style={{
                  color: "white",
                  marginLeft: "auto",
                  textTransform: "capitalize",
                  textAlign: "center",
                  paddingRight: "2%",
                }}
              >
                Job Ready Assessment
              </h3>
            </div>
          </nav>
        </div>

        {(loader || isLoading || isAnalysisGetLoading) && (
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1000,
            }}
            open={true}
          >
            <CircularProgress color="secondary" />
          </Backdrop>
        )}

        <Container
          maxWidth="xl"
          style={{
            textAlign: "center",
            minHeight: "80vh",
            marginBottom: "1%",
          }}
        >
          <Grid
            container
            style={{
              paddingBottom: "2%",
              backgroundColor: "#0F143C",
              // backgroundImage:
              //   "linear-gradient(to right, #000000, #19072f, #8224f3)",
              borderRadius: "10px",
            }}
          >
            <Grid item xs={12} md={12} lg={12} style={{ marginBottom: "2%" }}>
              <Box
                sx={{
                  margin: "2% 0 4% 0",
                  display: "flex",
                  justifyContent: "center",
                  padding: "0 4%",
                }}
              >
                {Array.from({ length: quesCnt + 1 }, (_, index) => (
                  <div
                    style={{
                      width: "8%",
                      height: "25px",
                      background: "#8063c0",
                      backgroundImage:
                        "linear-gradient(to right, #a884fc, #8364c2, #4d4066)",
                      borderRadius: "25px",
                      transition: "width 0.3s ease",
                      margin: "0 15px",
                    }}
                  />
                ))}
                {Array.from({ length: totalCnt - quesCnt }, (_, index) => (
                  <div
                    style={{
                      width: "8%",
                      height: "25px",
                      background: "#8063c0",
                      backgroundImage:
                        "linear-gradient(to right, #f0e9f5, #fefefe, #8c7b9e)",
                      borderRadius: "25px",
                      transition: "width 0.3s ease",
                      margin: "0 15px",
                    }}
                  />
                ))}
              </Box>

              {currQuestion.type === "radioOptions" ? (
                <RadioOptions
                  question={currQuestion}
                  quizData={quizData}
                  setQuizData={setQuizData}
                />
              ) : (
                <OptionsGrid
                  question={currQuestion}
                  quizData={quizData}
                  setQuizData={setQuizData}
                />
              )}
            </Grid>

            <Grid
              item
              xs={4}
              md={4}
              lg={4}
              style={{
                display: "flex",
                justifyContent: "left",
                paddingLeft: "5%",
              }}
            >
              <Button
                variant="text"
                style={{
                  fontSize: "24px",
                  color: "#8224f3",
                  cursor: currQuestion.no == 1 ? "not-allowed" : "pointer",
                }}
                onClick={handlePrevQuestion}
              >
                <ArrowBackIosNewOutlinedIcon /> PREV
              </Button>
            </Grid>

            <Grid item xs={4} md={4} lg={4} />

            <Grid
              item
              xs={4}
              md={4}
              lg={4}
              style={{
                display: "flex",
                justifyContent: "right",
                paddingRight: "5%",
              }}
            >
              <Button
                variant="text"
                style={{
                  fontSize: "24px",
                  color: "black",
                  backgroundColor: "white",
                  borderRadius: "25px",
                  padding: "0 7%",
                }}
                onClick={handleNextQuestion}
              >
                {currQuestion.no === totalCnt ? "Submit" : "NEXT"}
                {currQuestion.no !== totalCnt && <ArrowForwardIosRoundedIcon />}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Container>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
      />
    </div>
  );
};

export default Quiz;
